// Order constante

export const CASH = 'CASH';
export const ACCEPTED = 'ACCEPTED';
export const WAITING = 'WAITING';
export const DONE = 'DONE';
